import { render, staticRenderFns } from "./pruductFilter.vue?vue&type=template&id=b8ceaf6e&scoped=true"
import script from "./pruductFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./pruductFilter.vue?vue&type=script&setup=true&lang=js"
import style0 from "./pruductFilter.vue?vue&type=style&index=0&id=b8ceaf6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ceaf6e",
  null
  
)

export default component.exports